/* DHC v1035 — iOS product page horizontal-pan guard */
(function(){
  if(!document.body || !document.body.classList.contains('template-product')) return;
  var startX=0,startY=0;
  var allowed=function(el){
    return !!(el && el.closest && el.closest('.dhc-pdp__thumbs,.dhc-pdp-v931__thumbs,.is-mobile-swipe,[data-dhc-recommendations-content],table'));
  };
  document.addEventListener('touchstart',function(e){
    if(!e.touches || !e.touches[0]) return;
    startX=e.touches[0].clientX; startY=e.touches[0].clientY;
  },{passive:true});
  document.addEventListener('touchmove',function(e){
    if(allowed(e.target) || !e.touches || !e.touches[0]) return;
    var dx=e.touches[0].clientX-startX;
    var dy=e.touches[0].clientY-startY;
    if(Math.abs(dx)>Math.abs(dy) && Math.abs(dx)>6){ e.preventDefault(); }
  },{passive:false});
  var lock=function(){
    if(document.scrollingElement && document.scrollingElement.scrollLeft){document.scrollingElement.scrollLeft=0;}
    if(document.documentElement.scrollLeft){document.documentElement.scrollLeft=0;}
    if(document.body.scrollLeft){document.body.scrollLeft=0;}
  };
  window.addEventListener('scroll',lock,{passive:true});
  window.addEventListener('resize',lock,{passive:true});
  window.DHC_RELEASE=window.DHC_RELEASE||{};
  window.DHC_RELEASE.productHorizontalLock='v1035';
})();
